// Product page buy block: size-pill variant swap (with live price-row/button-label
// updates, beyond what the homepage grid's pill JS needs to do) and gallery sync
// (desktop thumbnail click, mobile thumbnail click, variant-driven image swap).
(function () {
  var section = document.querySelector('[data-candells-section="main-product"]');
  if (!section) return;

  // --- Size pills -----------------------------------------------------
  section.addEventListener('click', function (event) {
    var pill = event.target.closest('.candells-main-product__size-pill');
    if (!pill || pill.disabled) return;

    section.querySelectorAll('.candells-main-product__size-pill').forEach(function (p) {
      p.classList.remove('is-selected');
      p.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-selected');
    pill.setAttribute('aria-pressed', 'true');

    var input = section.querySelector('[data-candells-main-product-variant-input]');
    if (input) input.value = pill.dataset.variantId;

    var priceEl = section.querySelector('[data-candells-price]');
    if (priceEl) priceEl.textContent = pill.dataset.price;

    var priceMetaEl = section.querySelector('[data-candells-price-meta]');
    if (priceMetaEl) priceMetaEl.textContent = pill.dataset.priceMeta;

    var priceLabelEl = section.querySelector('[data-candells-price-label]');
    if (priceLabelEl) priceLabelEl.textContent = pill.dataset.price;

    var submitButton = section.querySelector('.candells-main-product__submit');

    document.dispatchEvent(
      new CustomEvent('candells:variant:picked', {
        detail: {
          variantId: pill.dataset.variantId,
          title: submitButton ? submitButton.dataset.candellsProductTitle : '',
          url: submitButton ? submitButton.dataset.candellsProductUrl : '',
          image: submitButton ? submitButton.dataset.candellsProductImage : '',
          size: pill.dataset.sizeLabel,
          price: pill.dataset.price,
        },
      })
    );

    // If this variant has its own photo (Shopify's per-variant image),
    // click whichever thumbnail(s) — desktop's, mobile's, or both, since
    // both stay in the DOM regardless of viewport — carry that image's id,
    // reusing their existing swap/scroll logic below instead of duplicating it.
    var variantImageId = pill.dataset.variantImageId;
    if (variantImageId) {
      section.querySelectorAll('[data-image-id="' + variantImageId + '"]').forEach(function (el) {
        if (el.click) el.click();
      });
    }
  });

  // --- Desktop thumbnail click swaps the primary image -----------------
  var primaryImg = section.querySelector('.candells-main-product__primary-img');
  section.querySelectorAll('[data-candells-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      section.querySelectorAll('[data-candells-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      if (primaryImg && thumb.dataset.fullSrc) {
        // A srcset (from image_tag's widths:) takes priority over .src in
        // the browser's image selection — clear it or the swap is a no-op.
        primaryImg.removeAttribute('srcset');
        primaryImg.removeAttribute('sizes');
        primaryImg.src = thumb.dataset.fullSrc;
      }
    });
  });

  // --- Mobile thumbnail click scrolls the slider + syncs active state ---
  var galleryMobile = section.querySelector('.candells-main-product__gallery-mobile');
  var mobileThumbs = section.querySelectorAll('[data-candells-mobile-thumb]');
  if (galleryMobile && mobileThumbs.length) {
    var track = galleryMobile.querySelector('.candells-main-product__slider');

    mobileThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mobileThumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        if (track) {
          var slideIndex = parseInt(thumb.dataset.slideIndex, 10) || 0;
          track.scrollTo({ left: slideIndex * track.clientWidth, behavior: 'smooth' });
        }
      });
    });

    galleryMobile.addEventListener('slideChanged', function (event) {
      var currentPage = event.detail && event.detail.currentPage;
      mobileThumbs.forEach(function (thumb) {
        var slideIndex = parseInt(thumb.dataset.slideIndex, 10) || 0;
        thumb.classList.toggle('is-active', slideIndex === currentPage - 1);
      });
    });
  }
})();
